exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-title{margin:30px 0 20px}.page-title__text{margin:10px 0;font-size:18px;font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#333}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Tube/screens/Index/style.css
 ** module id = 2725
 ** module chunks = 72
 **/